var exports = {
  "kL": "xf0b3b88a--e0819d--container",
  "X2": "xf0b3b88a--e0819d--answer_container",
  "UJ": "xf0b3b88a--e0819d--answers_view_all",
  "sX": "xf0b3b88a--e0819d--answers_view_all--active",
  "Lh": "xf0b3b88a--e0819d--moderation_container",
};

module.exports = exports;
